var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_2089)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.563 1.94598C25.9818 2.36706 26.2835 2.89128 26.4377 3.46624C26.9933 5.58207 27 9.99917 27 9.99917C27 9.99917 27 14.4163 26.4377 16.5321C26.2835 17.1071 25.9818 17.6313 25.563 18.0524C25.1441 18.4734 24.6226 18.7766 24.0506 18.9317C21.9458 19.4992 13.5 19.4992 13.5 19.4992C13.5 19.4992 5.05639 19.4992 2.9516 18.9317C2.37943 18.777 1.85773 18.474 1.43878 18.0528C1.01983 17.6317 0.718345 17.1073 0.564536 16.5321C0 14.4163 0 9.99917 0 9.99917C0 9.99917 0 5.58207 0.564536 3.46624C0.716983 2.88943 1.01786 2.36314 1.4369 1.94034C1.85594 1.51753 2.37836 1.21312 2.9516 1.05773C5.05416 0.490234 13.5 0.490234 13.5 0.490234C13.5 0.490234 21.9436 0.490234 24.0506 1.06667C24.6226 1.2217 25.1441 1.5249 25.563 1.94598ZM17.8155 9.99852L10.7988 14.0693V5.92773L17.8155 9.99852Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_2089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 19,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.1df7243c3fb0a65ad059a38e4755f7e0.svg";
export { ForwardRef as ReactComponent };